import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import { UndoableDTO } from 'src/dto/UndoableDTO'
import type { PickAndFlatten } from 'src/types'

import { typeSafeAssign } from '@/utils/common'

// TODO: Problem 펼치지 말고 Problem DTO 그대로 받기
type AdapterInterface = Pick<
  res.StudentWorksheetProblem,
  'result' | 'userAnswer' | 'handwrittenNoteUrl'
> &
  PickAndFlatten<res.StudentWorksheetProblem, 'problem'> & { problemId: number } & {
    virtualResult?: common.ScoringResult
    virtualUserAnswer?: string
  }

export class StudentWorksheetProblem extends UndoableDTO implements AdapterInterface {
  id = EMPTY_NUMBER_ID // StudentWorksheetProblem의 id
  userAnswer = ''
  problemId = EMPTY_NUMBER_ID // StudentWorksheetProblem 내부 Problem DTO의 id
  index = EMPTY_NUMBER_ID
  favorite = false
  answer = ''
  problemImageUrl = ''
  answerImageUrl = ''
  solutionImageUrl = ''
  handwrittenNoteUrl = null
  result = 'CORRECT' as AdapterInterface['result']
  type = 'MULTIPLE_CHOICE' as AdapterInterface['type']
  video = null as AdapterInterface['video']
  conceptName = ''
  tagTop = ''
  level = 1
  answerUnits = ''
  virtualResult: common.ScoringResult = 'NONE'
  virtualUserAnswer = ''
  videoMatched = true
  conceptId = EMPTY_NUMBER_ID
  sourceType: common.ProblemOriginType | undefined = undefined

  constructor(data?: AdapterInterface) {
    super()
    makeObservable(this, {
      id: observable,
      userAnswer: observable,
      result: observable,
      problemId: observable,
      index: observable,
      favorite: observable,
      answer: observable,
      problemImageUrl: observable,
      answerImageUrl: observable,
      solutionImageUrl: observable,
      handwrittenNoteUrl: observable,
      type: observable,
      video: observable,
      conceptName: observable,
      tagTop: observable,
      level: observable,
      answerUnits: observable,
      virtualResult: observable,
      virtualUserAnswer: observable,
      videoMatched: observable,
      conceptId: observable,
      sourceType: observable,
    })

    if (data) typeSafeAssign(this, data)
  }
}
